module.exports = __webpack_public_path__ + "media/1-6.3ed3226d.mp4";